<template>
    <div class="concentrate-container">

        <div class="concentrate-title-container">
            <span class="back"></span> <span
                class="title-name">Please Select Concentrate Tape</span>
        </div>

        <div v-for="(item, index) in concentrateTypeModeList" :key="index" class="mt-20">
            <div class=" diy-mode-container">
                <div v-for="(concentrate,i) in item"
                     @click="modifyConcentrate(concentrate)"
                     :class="[concentrate.pasteTypeName?`diy-mode-item`:`diy-mode-item-none`,
                 tempSelectedConcentrate &&( concentrate.id === tempSelectedConcentrate.id) ? `selected`: `normal`]"
                >{{concentrate.pasteTypeName}}
                </div>
            </div>
        </div>

        <div class="confirm" @click="confirm">Confirm</div>

    </div>

</template>

<script>
    import storeRepository from "../repository/store/StoreRepository"
    import {toast} from "../util/util"

    export default {
        name    : "ConcentrateSetting",
        props   : {
            tempSelectedConcentrate: {
                type   : Object,
                default: () => {
                    return {id: -1}
                }
            }
        },
        data() {
            return {
                temperatureGraphView   : null,
                canvasWidth            : "300px",
                selectedConcentrate    : {id: -1},
                temp: {id: -1}
            }
        },
        methods : {
            modifyConcentrate(item) {
                this.temp = item
                this.$emit("onModifyConcentrateChanged", item)
            },

            confirm() {
                if (this.tempSelectedConcentrate.id === -1) {
                    toast("Please select one")
                    return
                }
                this.selectedConcentrate = this.temp;
                storeRepository.saveSelectedConcentrate(this.selectedConcentrate)
                this.$emit("showConcentrateSettingChanged", false)
            }
        },
        watch   : {},
        computed: {
            concentrateTypeModeList() {
                const concentrateTypeList      = this.concentrateTypeList
                const groupConcentrateTypeMode = []
                let groupData                  = []
                var i                          = 0
                concentrateTypeList && concentrateTypeList.forEach((item, index) => {
                    item.tIndex = i++
                    this.$set(item, `isSelected`, false)
                    groupData.push(item)
                    if (groupData.length % 4 === 0) {
                        groupConcentrateTypeMode.push(groupData)
                        groupData = []
                    }
                })
                groupConcentrateTypeMode.push(groupData)

                const idle = 4 - groupData.length
                if (idle > 0) {
                    for (let j = 0; j < idle; j++) {
                        groupData.push("")
                    }
                }

                return groupConcentrateTypeMode
            },


            concentrateTypeList() {
                return this.$store.state.concentrateTypeList
            },

        }
    }
</script>

<style lang="scss" scoped>
    .concentrate-container {
        display: flex;
        width: 250px;
        padding: 22px;
        flex-direction: column;
        background-color: #333333;

        .concentrate-title-container {
            display: flex;
            color: #F6F6F6;
            flex-direction: row;
            align-items: center;

            .back {
                width: 3px;
                height: 9px;
                padding: 4px;
                margin-left: 8px;
                background-repeat: no-repeat;
                background-position: center center;
                background-size: cover;
                @include bg-image("../assets/back");
            }

            .title-name {
                flex: 1;
                text-align: center;
                margin-right: 26px;
                font-size: 12px;
            }
        }


        .diy-mode-container {
            display: flex;
            flex-direction: row;
            align-items: center;

            .diy-mode-item {
                flex: 1;
                font-size: 8px;
                text-align: center;
                margin: 2px;
                padding-top: 12px;
                padding-bottom: 12px;
                color: #F6F6F6;
                border-radius: 16px;

                &.selected {
                    color: #ED6C0F;
                    border: 1px solid #ED6C0F;
                }

                &.normal {
                    color: #F6F6F6;
                    border: 1px solid #F6F6F6;
                }
            }

            .diy-mode-item-none {
                flex: 1;
            }
        }
    }

    .confirm {
        margin-top: 20px;
        background: white;
        padding: 10px;
        text-align: center;
        border-radius: 10px;
        color: #000;
    }

</style>